import { datoxApiBaseUrl, datoxAuthHeaders } from "./api"
import { AutomationApiError } from "./automations"

export type ReportExportContext = {
  scopeLabel?: string
  dashboard_id: string
  revision: number
  revision_id: string
  kpi_hash?: string | null
  config: Record<string, unknown>
  datasets: { id: string; name: string; columns: { name: string }[]; rows: Record<string, string | number | boolean | null>[] }[]
  draft: boolean
  context: Record<string, unknown>
}

const path = (project: string, dashboard: string) => `${datoxApiBaseUrl()}/api/projects/${encodeURIComponent(project)}/dashboards/${encodeURIComponent(dashboard)}/exports`

export async function prepareReportExport(project: string, dashboard: string, revision: number): Promise<ReportExportContext> {
  const response = await fetch(`${path(project, dashboard)}/context?revision=${revision}`, { headers: await datoxAuthHeaders() })
  const value: unknown = await response.json()
  if (!response.ok) throw new AutomationApiError(response.status, value)
  return value as ReportExportContext
}

export async function exportDashboardPdf(project: string, dashboard: string, revision: number, html: string, filename?: string): Promise<Blob> {
  const response = await fetch(`${path(project, dashboard)}/render`, {
    method: "POST",
    headers: { ...(await datoxAuthHeaders()), "Content-Type": "application/json" },
    body: JSON.stringify({ revision, html, filename }),
  })
  if (!response.ok) throw new AutomationApiError(response.status, await response.json().catch(() => null))
  return response.blob()
}

export async function saveReportExport(project: string, dashboard: string, context: ReportExportContext, pages: string[], file: Blob, requestID: string) {
  const body = new FormData()
  body.set("file", file, "report.pdf")
  body.set("revision", String(context.revision))
  body.set("pages", JSON.stringify(pages))
  body.set("request_id", requestID)
  if (context.kpi_hash) body.set("kpi_hash", context.kpi_hash)
  const response = await fetch(path(project, dashboard), { method: "POST", headers: await datoxAuthHeaders(), body })
  const value: unknown = await response.json()
  if (!response.ok) throw new AutomationApiError(response.status, value)
  return value as { id: string }
}

export async function downloadReportExport(project: string, dashboard: string, id: string, name: string) {
  const response = await fetch(`${path(project, dashboard)}/${encodeURIComponent(id)}/download`, { headers: await datoxAuthHeaders() })
  if (!response.ok) throw new AutomationApiError(response.status, await response.json().catch(() => null))
  const url = URL.createObjectURL(await response.blob())
  const link = document.createElement("a")
  link.href = url
  link.download = `${name.replace(/[\\/]/g, "-")}.pdf`
  link.click()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
